import { RelateType } from "@/types/static.types";

export enum GroupActionTypes {
  GET_GROUP_LIST = "GET_GROUP_LIST",
  POST_ID_TO_SWITCH_GROUP = "POST_ID_TO_SWITCH_GROUP",
  SET_SELECTED = "SET_SELECTED",
}

export type Group = {
  createdAt: string;
  id: number;
  logoPhotoFile: {
    contentType: string;
    id: number;
    name: string;
    relateType: RelateType;
    relateTypeId: number;
    url: string;
  };
  logoPhotoFileId: number;
  name: string;
};

export type GroupList = Group[];

export type GroupDetail = { token: string; group: Group };

export type GroupState = {
  selected: boolean;
  list: Group[];
  group: Group;
};

interface GetGroupList {
  type: typeof GroupActionTypes.GET_GROUP_LIST;
  payload: Group[];
}

interface PostIdToSwitchGroup {
  type: typeof GroupActionTypes.POST_ID_TO_SWITCH_GROUP;
  payload: GroupDetail;
}

interface SetSelected {
  type: typeof GroupActionTypes.SET_SELECTED;
  payload: boolean;
}

export type GroupAction = GetGroupList | PostIdToSwitchGroup | SetSelected;
